import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { DataLayer } from '@grandvisionhq/analytics';
import { Link } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { slugify } from '@grandvisionhq/utils';
import { storeGroupEvent } from '../../data-layer/actions.js';

const StoresOverviewRoot = (_param)=>{
    var { storeGroups , storeLocatorURL , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeGroups",
        "storeLocatorURL",
        "className"
    ]);
    const onClick = React.useCallback((city)=>{
        const dataLayerEvent = storeGroupEvent({
            interaction: 'city click',
            step: 'store group overview',
            city
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !!storeGroups && Object.keys(storeGroups).length > 0 ? /*#__PURE__*/ React.createElement("article", swcHelpers.extends({}, rest, {
        className: classnames('store-overview-stores-v2', className)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "store-overview-stores-v2__store-groups"
    }, Object.keys(storeGroups).map((groupName, index)=>{
        var ref;
         return React.createElement("div", {
            key: index,
            className: "store-overview-stores-v2__store-groups-item"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "store-overview-stores-v2__store-groups-item-name-container"
        }, /*#__PURE__*/ React.createElement("p", {
            className: "store-overview-stores-v2__store-groups-item-name"
        }, groupName), /*#__PURE__*/ React.createElement(Hr, null)), (ref = storeGroups[groupName]) === null || ref === void 0 ? void 0 : ref.map((storeGroup)=>{
            const path = storeGroup.store ? `${storeLocatorURL}/${slugify(storeGroup.store.town)}/${storeGroup.store.slug || ''}` : `${storeLocatorURL}/${storeGroup.slug || ''}`;
            return /*#__PURE__*/ React.createElement("div", {
                key: storeGroup.name,
                className: "store-overview-stores-v2__store-groups-item-link-container"
            }, /*#__PURE__*/ React.createElement(Link, {
                onClick: ()=>onClick(storeGroup.name)
                ,
                url: path
            }, storeGroup.name));
        }));
    }))) : null);
};

export { StoresOverviewRoot as default };
//# sourceMappingURL=StoresOverviewRoot.js.map
